import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgListLong = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 13,
	viewBox: "0 0 14 13",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1.66602 5.0013H12.3327M1.66602 8.33464H12.3327M1.66602 11.668H6.99935M1.66602 1.66797H12.3327",
		stroke: "#FAFAFA",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgListLong);
export default ForwardRef;
